import { IonSpinner } from "@ionic/react";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useRef, useState } from "react";
import InputV1 from "_+_Portal/components/Genericos/InputV1/InputV1";
import { PortalContext } from "_+_Portal/context/Provider";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import {
  wsGetValidaOnlineToken,
  wsPostValidaOnline,
} from "_+_Portal/_-_Autocheckin/context/action/validaCobertura";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { proximoPaso } from "../PagesFun";
import {
  Paso3Body,
  Paso3Container,
  Paso3ContainerBotones,
  Paso3ContainerBotonesSMG,
  Paso3SMGContainer,
  Paso3Titulo,
} from "./localStyle";
import ModalToken from "_+_Portal/_-_Autocheckin/components/genericos/ModalToken/ModalToken";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { wsGetTurnoByIdQr } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { showToaster } from "global/context/action/toaster/toaster";

const ValidarCobertura = ({ turnoActual }) => {
  // -------------------------  context ----------------------------
  const {
    turnosSeleccionadosState,
    rutaState,
    pasoDispatch,
    rutaDispatch,
    puntoControlDispatch,
  } = useContext(AutocheckContext);

  const { authState, modalDispatch, toasterDispatch } =
    useContext(GlobalContext);

  const { selectDropDownState } = useContext(PortalContext);
  // -------------------------  context ----------------------------

  // -------------------------  useStates ----------------------------
  const [token, setToken] = useState({ token: false });
  const [loading, setLoading] = useState(true);
  const [esSMG, setEsSMG] = useState(null);
  const [esAccord, setEsAccord] = useState(null);
  // -------------------------  useStates ----------------------------

  // -------------------------  constantes ----------------------------
  const bodyTxt =
    "Ingresá el token o código de seguridad que figura en la aplicación de tu cobertura médica.";
  const bodyTxtSmg =
    "Le pedimos que nos indique si cuenta con la aplicación de la cobertura para usar el token de autorización o si tiene la credencial física";
  const titleTxtSmg = "Autorización de la cobertura";
  const bodyTxtAccord =
    "¿Cuenta con la aplicación de su cobertura para utilizar el token de seguridad?";
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados.data;
  const turno = listTurnosSeleccionado[turnoActual];
  const paciente = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
    : authState.auth.data.paciente;

  const intentos = useRef(0);

  const idPacFamiliar = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.codigo
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.codigo
    : false;
  const titleTxtAccord = "Autorización de la cobertura";
  // -------------------------  constantes ----------------------------

  // -------------------------  funciones ----------------------------
  const handleClickVolver = () => {
    setPaso("TurnosDelDia")(pasoDispatch);
  };
  const dissmiss = () => {
    setLoading(false);
    hideModal()(modalDispatch);
  };

  const ingresarToken = (e) => {
    setToken({ token: e.target.value });
  };

  const nextStep = () => {
    if (typeof token.token === "string" && token.token.length > 0) {
      let dto = {};
      dto["tipoProceso"] = "2";
      dto["idTurno"] = turno.idturno;
      dto["idPaciente"] = paciente.codigo;
      dto["osToken"] = token.token;
      setLoading(true);
      wsPostValidaOnline([dto], finalizar);
    } else {
      showToaster(
        {
          texto: "Debes ingresar el token de tu cobertura para continuar.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };
  const updateTurno = (isCorrect, data) => {
    let pathUpdated = [];
    const ruta = rutaState.ruta.data;
    if (isCorrect) {
      if (data?.resumen?.monto) {
        pathUpdated.push("AbonarMP");
      }
      pathUpdated.push(ruta.pop());
      setRuta(proximoPaso(pathUpdated, setPaso, pasoDispatch))(rutaDispatch);
    }
  };
  const finalizar = (success, data) => {
    if (success && data?.success > 0) {
      setLoading("Actualizando información de turno...");
      wsGetTurnoByIdQr(turno.idturno, updateTurno);
    } else {
      if (intentos.current < 3) {
        intentos.current = intentos.current + 1;
        if (esSMG) {
          showToaster(
            {
              texto: "Ha ocurrido un error al intentar validar",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
        } else {
          showModal(
            <ModalToken dissmiss={dissmiss} />,
            "Ups! Algo salió mal",
            dissmiss,
            false,
            {},
            "centro",
            true
          )(modalDispatch);
        }
      } else {
        irPuntoDeControl();
      }
    }
  };

  const irPuntoDeControl = () => {
    setLoading(true);
    const idTipoPuntoControl = 9;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  const pedirToken = () => {
    setEsSMG(false);
  };

  const puntoControlAccord = () => {
    const idTipoPuntoControl = 9;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  const validarSinToken = () => {
    let dto = {};
    dto["tipoProceso"] = "2";
    dto["idTurno"] = turno.idturno;
    dto["idPaciente"] = paciente.codigo;
    setLoading(true);
    wsPostValidaOnline([dto], finalizar);
  };

  // -------------------------  funciones ----------------------------

  // -------------------------  useEffect ----------------------------
  useEffect(() => {
    let nextStep = (success, data) => {
      if (success && data.token) {
        if (data.preguntarToken) {
          setEsSMG(data.preguntarToken);
          setEsAccord(data.preguntarToken);
        } else if (data.preguntarAppPaciente) {
          setEsSMG(data.preguntarAppPaciente);
        } else {
          setToken({ ...data });
        }
        setLoading(false);
      } else if (success) {
        let dto = {};
        dto["tipoProceso"] = "2";
        dto["idTurno"] = turno.idturno;
        dto["idPaciente"] = paciente.codigo;
        wsPostValidaOnline([dto], finalizar);
      }
    };
    wsGetValidaOnlineToken(turno.idturno, nextStep);
  }, []);
  // -------------------------  useEffect ----------------------------

  return (
    <LayoutPasos
      handleClick={handleClickVolver}
      volverTo={"/autocheckin/resumen"}
      type={"no-circle"}
      title={"Validación online"}
    >
      <CardBlueHeart
        medico={turno.medico ? turno.medico : turno.especialidad}
        turnoTitle={turno.especialidad}
        pasoActual={turnoActual + 1}
        pasoTotal={listTurnosSeleccionado.length}
      />
      {loading ? (
        <Paso3Container>
          <span className={"spinner"}>
            <IonSpinner name="lines" />
          </span>
        </Paso3Container>
      ) : (
        <>
          {esSMG ? (
            <>
              <Paso3SMGContainer
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.4 }}
              >
                <Paso3Body>
                  <span className="rb22b ValidaTurnoSmg-titulo">
                    {esAccord ? titleTxtAccord : titleTxtSmg}
                  </span>
                </Paso3Body>
                <Paso3Body>
                  <span className="rb18l ValidaTurnoSmg-bodytxt">
                    {esAccord ? bodyTxtAccord : bodyTxtSmg}
                  </span>
                </Paso3Body>

                {esAccord ? (
                  <Paso3ContainerBotonesSMG>
                    <button
                      className="btn btn-validaturno bgc-primary c-white rb18m"
                      onClick={pedirToken}
                    >
                      SI
                    </button>
                    <button
                      className="btn btn-validaturno bgc-danger c-white rb18m"
                      onClick={puntoControlAccord}
                    >
                      NO
                    </button>
                  </Paso3ContainerBotonesSMG>
                ) : (
                  <Paso3ContainerBotonesSMG>
                    <button
                      className="btn btn-validaturno bgc-primary c-white rb18m"
                      onClick={pedirToken}
                    >
                      Aplicación de cobertura
                    </button>
                    <button
                      className="btn btn-validaturno bgc-primary c-white rb18m"
                      onClick={validarSinToken}
                    >
                      Credencial
                    </button>
                  </Paso3ContainerBotonesSMG>
                )}
              </Paso3SMGContainer>
            </>
          ) : (
            <Paso3Container
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.4 }}
            >
              <PasoBar paso={"ValidarCobertura"} />
              <Paso3Titulo>
                <span className="rb18m">Validación</span>
              </Paso3Titulo>
              <hr className="ValidaTurno-separador"></hr>
              <Paso3Body>
                <span className="ValidaTurno-bodytxt">{bodyTxt}</span>
                <div className="ValidaTurno-input">
                  <InputV1
                    clase="ValidaTurno-input"
                    placeholderText={"12254"}
                    onChange={ingresarToken}
                    inputType="number"
                  />
                </div>
              </Paso3Body>
              <Paso3ContainerBotones>
                <button
                  className={`btn btn-validaturno bgc-danger c-white rb16m`}
                  onClick={irPuntoDeControl}
                >
                  No lo tengo
                </button>
                <button
                  className={`btn btn-validaturno ${
                    token.token === "" ? "bgc-grey65" : "bgc-primary"
                  } c-white rb16m`}
                  onClick={nextStep}
                >
                  Enviar
                </button>
              </Paso3ContainerBotones>
            </Paso3Container>
          )}
        </>
      )}
    </LayoutPasos>
  );
};

export default ValidarCobertura;
